<template>
	<b-container fluid class="mt-4">
        <template v-if="versions.length || !!latestFile">
			<h3>Latest Version</h3>
			<a class="btn btn-success btn-lg mt-2" :href="latestFile.url" target="_blank">
				Download {{ latestFile.filename }}
			</a>
			<br />
			<span class="file-created">{{ latestFile.created_at }}</span>

			<h3 class="mt-4">Previous Versions</h3>
			<ul>
				<li
					v-for="file in versions"
					:key="file.id"
				>
					<a :href="file.url" target="_blank">
						{{ file.filename }}
						<span class="file-created">{{ file.created_at }}</span>
					</a>
				</li>
			</ul>
		</template>
	</b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'ImporterDownload',
	computed: {
		versions() {
			if (!this.filesByGroup || !this.filesByGroup[this.group.id]) return [];

			return this.filesByGroup[this.group.id].filter(v => v.id !== this.latestFile.id);
		},
		group() {
			return this.groups.find(g => g.name === 'importer-builds') || {};
		},
		...mapState(['filesByGroup', 'groups', 'latestFile']),
	},
	async created() {
		await this.fetchGroups();
		this.fetchFiles({groupId: this.group.id});
	},
	methods: {
		openFile(fileId) {
			this.$router.push({
				name: 'file',
				params: {fileId},
			});
		},
		...mapActions(['fetchFiles', 'fetchGroups']),
	}
}
</script>

<style scoped>
    ul {
        padding: 0;
        list-style-type: none;
    }

	li {
		font-size: 1.7rem;
	}

	.file-created {
		font-size: 1rem;
		color: #888;
	}
</style>
